<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `projects`}">Video Templates</b-link> / Create</span>

        <b-button size="sm" variant="outline-primary" class="float-right" href="https://support.vidon.ai/41dad51e02d8439e874ffab6dbe0a96f" target="_blank"><i class="fad fa-question-circle mr-2"></i>Video creation guide</b-button>
      </template>

      <b-form @submit.stop.prevent="create_item">
        <b-form-group invalid-feedback="Must be greater then 4 character">
          <b-form-input v-model="item.name" required placeholder="Video name" :state="validate_state('name')" style='max-width: 264px'></b-form-input>
        </b-form-group>

        <b-alert :show="!item.voice_doc" variant='warning'>
          You don't have an active avatar, you cannot create a project.
        </b-alert>

        <b-card no-body v-if="!item.video_url">
          <b-tabs card>
            <b-tab title="Record" active>
              <b-row>
                <b-col>
                  <VideoRecorder :on_complete="upload_video" :max_limit="60" :uploading_progress="uploading_progress"/>
                </b-col>
                <b-col>
                  <b-form-group class="mb-2">
                    <b-dropdown text="View templates" size="sm">
                      <b-dropdown-item @click="select_template(temp)" v-for="temp in Object.keys(SCRIPT_TEMPLATES)" :key="temp">{{temp}}</b-dropdown-item>
                    </b-dropdown>
                  </b-form-group>
                  <b-textarea placeholder='Write your script here e.g. "Hey name, ..."' rows="13" v-model='script' />
                </b-col>
            </b-row>

              <!-- <VideoRecorder2 :on_complete="upload_video" :max_limit="60"/> -->
            </b-tab>
            <b-tab title="Upload">
              <p>Upload an MP4 video saying <i>"Hi name, ..."</i> (max 1 minute, 5MB)</p>
              <b-input-group>
                <b-form-file v-model="file" placeholder="Choose a Video" drop-placeholder="Drop MP4 file here..." accept="video/*"></b-form-file>
                <b-input-group-append>
                  <LoadingButton :loading="is_uploading" @click="upload_video" :uploading_progress="uploading_progress" post_upload="Transcribing">Upload</LoadingButton>
                </b-input-group-append>
              </b-input-group>
            </b-tab>
          </b-tabs>

          <!-- <b-alert :show='true' variant='info' class='mx-3 mb-4'>

            <b-button class='p-0'>
              <div class='p-2'>
                <b-spinner small v-if="uploading_progress === null && is_uploading"></b-spinner>
                <span v-if="uploading_progress === 100">Transcribing</span>
                <span v-else>Upload</span>
              </div>
              <b-progress v-if="uploading_progress !== null" :value="uploading_progress" variant="primary" height="3px"></b-progress>
            </b-button>

          </b-alert> -->
        </b-card>
        <div v-else>
          <video :src="item.video_url" width="360" controls></video>
          <p><b-button variant='warning' @click="clear_video">Clear</b-button></p>

          <h4>Variables</h4>
          <Transcript :transcript="item.transcript" :variables="variables.map(a => a.word)"/>
          <b-alert :show="words.length === 0" variant="warning">We couldn't hear you say a varaible. Please try again and clearly say the variable "<strong>name</strong>".</b-alert>
          <b-form-group v-if="words.length > 0">
            <b-row v-for="(variable, index) in variables" v-bind:key="index">
              <b-col>
                <b-form-select v-model="variable.word" :options="words_not_used" style='max-width: 264px'></b-form-select>
              </b-col>
            </b-row>
          </b-form-group>

          <div v-if="profile.role === 'admin'">
            <b-form-group label="Clone:" description="Note you can only select voices which have completed processing">
              <b-form-select v-model="item.voice_doc" required :options="voice_options"></b-form-select>
            </b-form-group>
          </div>

          <h4>Call to action</h4>
          <p>Add an call to action to show when the video has completed (leave blank to exclude)</p>
          <b-form-group>
            <b-form-input v-model="item.cta_text" placeholder="Learn more" class='d-inline mr-2' style='max-width: 264px'></b-form-input>
            <b-form-input v-model="item.cta_url" type="url" placeholder="https://example.com"  class='d-inline' style='max-width: 264px'></b-form-input>
          </b-form-group>

          <div v-if="profile.role === 'admin'">
            <b-form-group>
              <b-form-input v-model="item.secondary_cta_text" placeholder="Learn more" class='d-inline mr-2' style='max-width: 264px'></b-form-input>
              <b-form-input v-model="item.secondary_cta_url" type="url" placeholder="https://example.com" class='d-inline' style='max-width: 264px'></b-form-input>
            </b-form-group>
          </div>

          <h4>Cards</h4>
          <Cards :item="item" />

          <!-- <b-row>
            <b-card-group class='w-100' deck>
              <b-card title='Try it out today' class='p-4'>
                <b-card-text>Fallback if video cannot be created due to an error Fallback if video cannot be created due to an error Fallback if video cannot be created due to an error</b-card-text>
                <b-link class='text-primary'>Learn more</b-link>
              </b-card>
              <b-card title='Learn more about deepfakes' class='p-4'>
                <b-card-text>Fallback if video cannot be created due to an error Fallback </b-card-text>
                <b-link class='text-primary'>Learn more</b-link>
              </b-card>
              <b-card title='Learn more about deepfakes' class='p-4'>
                <b-card-text>if video cannot be created due to an error Fallback if video cannot be created due to an error</b-card-text>
                <b-link class='text-primary'>Learn more</b-link>
              </b-card>
            </b-card-group>
          </b-row> -->

          <!-- <h4>Presentation</h4>
          <b-row>
            <b-col>
              <p>Change how the video appears</p>
              <b-form-group>
                <b-form-select v-model="item.presentation" :options="['fullscreen', 'website']"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <p>Video Preview</p>
              <img v-if="item.presentation === 'fullscreen'" src="@/assets/presentation_fullscreen.png" class="presentation_preview"/>
              <img v-if="item.presentation === 'website'" src="@/assets/presentation_website.png"  class="presentation_preview"/>
            </b-col>
          </b-row> -->

          <!-- TODO add , 'video', 'image' -->

          <h4>Video fallback</h4>
          <p>Fallback if video cannot be created due to an error</p>

          <div v-if="!item.fallback_video_url">
            <VideoRecorder :on_complete="upload_fallback_video" :max_limit="60" class="mb-4"/>
          </div>
          <div v-else>
            <video :src="item.fallback_video_url" width="360" controls></video>
            <p><b-button variant='warning' @click="clear_fallback_video">Clear</b-button></p>
          </div>

          <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
        </div>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import { db, storage, FieldValue, config, _firebase } from '@/main.js'
import api from '@/lib/api.js'
import constants from '@/lib/constants.js'
import VideoRecorder from '@/components/VideoRecorder.vue'
import Transcript from "@/components/Transcript.vue"
import Cards from "@/components/Cards.vue"
// import VideoRecorder2 from '@/components/VideoRecorder2.vue'

const SCRIPT_TEMPLATES = {
  'First-touch Intro': "Hey name!\n\nIt’s [your name] with [your company]\n\nI made this video to send to you so you could see the value of having a personalized video in an email message.\n\nAt [company] we use this tactic in a variety of ways from following up on discussions to introducing ourselves to clients during the onboarding process.\n\nI’d love to schedule a meeting with you to dig deeper into your sales process to identify opportunities to use video.\n\nThanks for watching and talk to you soon",
  'First-touch Intro 2': "Hi name,\n\nI’m [your name] from [your company]. I’m reaching out because [succinctly state that value proposition your product can offer.]\n\nWe help [SMBs/mid-market/enterprise companies] in [insert vertical like healthcare or fintech] improve their [success metrics you help boost like MQL conversion, revenue growth, time-to-value.]\n\nWe recently helped [name] from [company name ideally in the same space] go from [dismal baseline] to [amazing metric] in only [impressively minimal timeframe.]\n\nI’d love to chat and tell you more [same name]’s story at 1 PM this Thursday. Does that work?",
  'First-touch Intro 3': "Hi name.\n\nSince you [work in X role, have Y responsibility, likely face Z challenge], I wanted to share [tip] with you.\n\nIf you want to talk about this more, let’s set up a call.\n\nTalk to you soon.",
  'First-touch Intro 4': "Hey name.\n\nI’m sending you a link to a great [blog post, ebook, podcast, webinar] on [relevant topic] -- but I know you’re probably super busy.\n\nSo if you don’t have time to [watch, read] the whole thing, here are the most important points:\n[Point #1]\n[Point #2]\n[Point #3]\n\nIf you want to talk about this more, schedule time with me using the link at the end.\n\nHave a great day.",
  'First-touch Intro 5': "Hey name.\n\nWanted to send you a quick video explaining what [company] does, and more importantly, why you should care.\n\nWe [focus on, specialize in] helping [X type of prospects solve Y type of problem].\n\nI’d love to learn more about your company and how we can help you.\n\nPlease schedule some time on my calendar using the link at the end.\n\nTalk to you soon.",
  'Inbound Lead Follow-Up': "Hi name,\n\nThanks for reaching out.\n\nMy name is [your name] I'm [job title] at [your company].\n\nWe’re a team of experts who can solve ...\n\nLet's set up a call to discover where we can help.\n\nLooking forward to speaking",
  'Lead gone cold': "Hi name.\n\nI hate sending irritating 'just checking in' emails … So instead I’m sending an irritating 'just checking in' video.\n\nOkay, hopefully it’s not too irritating.\n\nLet’s schedule a call to discuss your goals for X and how [your company] can make those happen.",
  'Lead gone cold 2': "Hi name,\n\nOver the last few weeks I have tried to get in touch with you and your team.\n\nRecognizing the current state of the industry I can only imagine the strain you might be under. That in mind, I went and downloaded our 2021 Marketing Insights whitepaper for you. Perhaps you'll will find value in the resource when strategizing for what’s to come.\n\nMy hope is that you takeaway some good insights from my past emails and that this last one serves as a good next step to helping you.\n\nShould you ever want to discuss strategy, GTM plans or growth models I am always happy to reconnect with you - I might send you resources from time to time as well in hopes of continuing to help from the sidelines. \n\nBe well, I’m here if you ever need me",
  'Reviving a Dead Opportunity': "Hey name,\n\nI wanted to send you a video because back when we last spoke the timing wasn't right.\n\nI wanted to see if your priorities have shifted, or maybe if this is a better time to chat\n\nI would love to jump on a quick call to sync up and see if we can provide value and help.\n\nLooking forward to speaking",
  'Upsell/Re-engagement': "Hi name,\n\nI wanted to send you a video because we've recently released some new features I thought you'd be interested in.\n\n[features]\n\nI would love to jump on a call to give you some more details on these.\n\nThanks for watching.",
}


function compare(str1, str2) {
  let _str1 = str1.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ").toLowerCase()
  let _str2 = str2.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ").toLowerCase()

  return _str1 === _str2
}

export default {
  metaInfo: {title: 'Video create'},
  mixins: [ItemMixin],
  components: {VideoRecorder, Transcript, Cards},
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  firestore: function () {
    let voices = db.collection('voice').where('status', '==', 'complete').where('user', '==', this.profile.id)
    if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
      voices = db.collection('voice').where('status', '==', 'complete').where('team', '==', db.collection('team').doc(this.profile.team.id))
    }

    if (this.profile.role === 'admin') {
      voices = db.collection('voice').where('status', '==', 'complete')
    }

    return {
      _item: db.collection(this.collection).doc(this.item_id),
      voices: voices.orderBy('created', 'desc')
    }
  },
  data() {
    let item_id = db.collection('random').doc().id

    // let video_url = 'https://firebasestorage.googleapis.com/v0/b/puppet-dev.appspot.com/o/AJvJkfrukbTrPns9ukOtykkBK0H2%2Fvideos%2FrCID7XAUKsUn5opwn4vB?alt=media&token=b1d53619-83ad-4404-b147-aaa6bd78c166'
    // let word_time_offsets = [{ word: 'Hello,', start: 1.1, end: 1.6 },{ word: 'this', start: 1.6, end: 1.8 },{ word: 'is', start: 1.8, end: 2 },{ word: 'a', start: 2, end: 2 },{ word: 'test', start: 2, end: 2.7 },{ word: 'to', start: 2.7, end: 3.1 },{ word: 'see', start: 3.1, end: 3.6 },{ word: 'what', start: 3.6, end: 3.8 },{ word: 'about', start: 3.8, end: 4.1 },{ word: 'custom', start: 4.1, end: 4.5 },{ word: 'variables?', start: 4.5, end: 5 }]
    // let transcript = 'Hello, this is a test to see what about custom variables?'

    return {
      uploading_progress: null,
      item_id: item_id,
      collection: 'project',
      voices: [],
      SCRIPT_TEMPLATES: SCRIPT_TEMPLATES,
      variables: [{word: null}],
      is_uploading: false,
      script: '',
      words: [],
      item: {
        status: 'pending',
        presentation: 'website',
        quality_control: true,
        name: '',
        cards: [],
        video_url: null,
        fallback_video_url: null,
        thumbnail_url: null,
        variables: [],
        cta_text: null,
        cta_url: null,
        background: null,
        background_audio: 'https://assets.getvidon.com/room_tone.mp3',
        voice_doc: db.collection('voice').doc(this.profile.avatar.id),
        subscriptions: [],
        transcript: '',
        word_time_offsets: [],
        items_count: 0,
        generation_type: 'face',
        video_player_url: `https://${config.firebase_config.video_domain}/video/?project=${encodeURIComponent(item_id)}`
      },
      file: null
    }
  },
  computed: {
    presentation_description() {
      if (this.item.presentation === 'fullscreen') {
        return 'The video above will be shown'
      } else if (this.item.presentation === 'website') {
        return 'If a url is provided a video of the recipients website is shown with the video above in the bottom left'
      } else {
        return ''
      }
    },
    voice_options() {
      let voice_options = []
      for (let voice of this.voices) {
        voice_options.push({text: voice.name, value: db.collection('voice').doc(voice.id)})
      }

      return voice_options
    },
    words_not_used() {
      let words_not_used = ['']
      for (let word of this.words) {
        let used = false
        for (let v of this.variables) {
          if (v === word) {
            used = true
            break
          }
        }

        if (!used) {
          words_not_used.push(word)
        }
      }

      return words_not_used
    }
  },
  watch: {
    // 'voices': {
    //   deep: true,
    //   handler: function(val) {
    //     if (this.item.voice_doc === null && val.length) {
    //       this.item.voice_doc = db.collection('voice').doc(this.profile.avatar.id)
    //     }
    //   }
    // },
    'variables': {
      deep: true,
      handler: function(val) {
        let last_item = val[val.length-1]
        if (last_item.word !== null && this.variables.length < this.words.length) {
          this.variables.push({word: null})
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'project') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  methods: {
    select_template(key) {
      this.script = SCRIPT_TEMPLATES[key]
    },
    upload_progress(snapshot) {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      this.uploading_progress = progress
      switch (snapshot.state) {
        case _firebase.storage.TaskState.PAUSED: // or 'paused'
          break;
        case _firebase.storage.TaskState.RUNNING: // or 'running'
          break;
      }
    },
    async clear_video() {
      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      this.item.transcript = ''
      this.item.word_time_offsets = []
      this.item.video_url = null
      this.file = null
    },
    async clear_fallback_video() {
      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      this.item.fallback_video_url = null
    },
    video_duration(src) {
      return new Promise((resolve, reject) => {
        try {
          let video = document.createElement('video')
          video.preload = 'metadata'

          video.onloadedmetadata = function () {
            resolve(this)
          }

          video.onerror = function () {
            reject("Invalid video. Please select a video file.")
          }

          // video.src = window.URL.createObjectURL(file)
          video.src = src
        } catch (e) {
            reject(e)
        }
      })
    },
    async video_to_text(video_url) {
      let response = await api.video_to_text(video_url)
      return response.data
    },
    async upload_video(raw_data) {
      if (this.file) {
        raw_data = this.file
      }

      let src = window.URL.createObjectURL(raw_data)

      if (!src) {
        this.$swal({title: 'No file', text: "Please upload a video file", icon: 'warning'})
        return false
      }

      // const MAX_SIZE = 5 * 1048576 // 5 MB
      // if (this.file.size > MAX_SIZE) {
      //   this.$swal({title: 'Invalid video', text: `Please upload a video file < 5MB. Your video is ${(this.file.size / 1048576).toFixed(0)}MB`, icon: 'warning'})
      //   return false
      // }

      let video
      try {
        video = await this.video_duration(src)
      } catch (err) {
        this.$swal({title: 'Invalid video', text: "Please upload a valid MP4 video file", icon: 'warning'})
        return false
      }

      // if (video.duration > 60) {
      //   this.$swal({title: 'Invalid video', text: `Please upload a video file < 60 seconds. Your video is ${video.duration.toFixed(0)}s`, icon: 'warning'})
      //   return false
      // }

      // if (video.videoWidth > 1080 || video.videoWidth < 420 || video.heightWidth > 720 || video.heightWidth < 320) {
      //   this.$swal({title: 'Invalid video', text: `Please upload a video between 420x320 and 1080x720. Your video is ${video.videoWidth}x${video.heightWidth}`, icon: 'warning'})
      //   return false
      // }

      this.is_uploading = true
      this.uploading_progress = 0

      let snap = storage.ref().child(`project/${this.item_id}/video.webm`).put(raw_data)
      snap.on('state_changed', this.upload_progress)
      snap = await snap

      let url = await snap.ref.getDownloadURL()

      let result
      try {
        result = await this.video_to_text(url)
      } catch (err) {
        console.warn(err)
        this.$swal({title: 'Failed to transcribe', text: "Please ensure the video is less than 1 minute", icon: 'warning'})
        this.is_uploading = false
        this.uploading_progress = null
        return false
      }

      this.is_uploading = false
      this.uploading_progress = null

      this.words = []

      for (let word of result.words) {
        if (this.words.indexOf('name') == -1 && compare(word, 'name')) {
          this.words.push('name')

          if (this.variables[0].word === null) {
            this.variables[0].word = 'name'
          }
        }

        if (this.profile.role === 'admin') {
          if (this.words.indexOf('company') == -1 && compare(word, 'company')) {
              this.words.push('company')
          }
          if (this.words.indexOf('one') == -1 && compare(word, 'one')) {
              this.words.push('one')
          }
          if (this.words.indexOf('two') == -1 && compare(word, 'two')) {
              this.words.push('two')
          }
          if (this.words.indexOf('three') == -1 && compare(word, 'three')) {
              this.words.push('three')
          }
        }
      }

      if (this.profile.role === 'admin') {
        this.words.push('script')
      }

      // this.item.words = result.words
      this.item.transcript = result.transcript
      this.item.word_time_offsets = result.word_time_offsets
      this.item.video_url = url
      this.file = null
    },
    async upload_fallback_video(raw_data) {
      let src = window.URL.createObjectURL(raw_data)

      if (!src) {
        this.$swal({title: 'No file', text: "Please upload a video file", icon: 'warning'})
        return false
      }

      let snap = await storage.ref().child(`project/${this.item_id}/fallback_video.mp4`).put(raw_data)
      let url = await snap.ref.getDownloadURL()

      this.item.fallback_video_url = url
    },
    async do_before() {
      let cta_url = this.item.cta_url || ''
      if (cta_url && !cta_url.match(/https?:\/\//)) {
        cta_url = `https://${cta_url}`
      }
      if ((this.item.cta_text && !cta_url) || (!this.item.cta_text && cta_url)) {
        await this.$swal({title: 'Setup call to action', text: "Please add both text and URL if you want a call to action", icon: 'warning'})
        return false
      }

      this.item.cta_url = cta_url

      let variables = []
      for (let variable of this.variables) {
        if (variable.word !== null && variable.word !== '') {
          variables.push({word: variable['word'], prefix_words: 1, suffix_words: 0, speed: 1.0, volume: 0.0})
        }
      }

      if (variables.length === 0) {
        let result = await this.$swal({
          title: 'No Variables',
          text: "You don't have any variables, nothing will be replaced!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Continue'
        })

        if (!result.value) {
          return false
        }
      }

      if (!this.item.fallback_video_url) {
        let result = await this.$swal({
          title: 'No fallback',
          text: "You don't have a fallback video, are you sure you want to continue?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Continue'
        })

        if (!result.value) {
          return false
        }
      }

      this.item.variables = variables

      return true
    },
    async do_after() {
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), projects_count: FieldValue.increment(1)})
    }
  }
}
</script>

<style>

.presentation_preview {
  max-width: 300px;
  border: 1px solid black;
  margin: auto;
  text-align: center;
}

</style>
